if (!customElements.get('l-faqs-search')) {
	customElements.define(
		'l-faqs-search',
		class LTAFAQsSearch extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				// Elements
				this.searchInputEl = this.querySelector('[data-search-input]')
				this.tagEls = this.querySelectorAll('[data-search-tag]')
				this.collapsibleTabEls = this.querySelectorAll('l-collapsible-tab')
				this.categoryEls = this.querySelectorAll('[data-category]')
				this.viewMoreBtnEl = this.querySelector('[data-view-more-btn]')

				// Data
				this.questionsPerPage = parseInt(this.dataset.questionsPerPage) || 5
				this.allValidQuestions = this.collapsibleTabEls.length
				this.currentShowingQuestions = this.questionsPerPage
				this.tagMode = ''
				this.searchMode = ''

				// Setup events
				this.handleTagClickEvent()
				this.handleViewMoreClickEvent()
				this.handleSearchEvent()
			}

			handleSearchEvent() {
				if (!this.searchInputEl) return

				this.searchInputEl.addEventListener(
					'input',
					debounce(() => {
						this.searchMode = this.searchInputEl.value.toLowerCase()

						this.updateTabs()
					}, 300)
				)
			}

			handleTagClickEvent() {
				this.tagEls.forEach((tagEl) => {
					tagEl.addEventListener('click', () => {
						const isSelected = tagEl.classList.contains('is-selected')

						if (isSelected) {
							tagEl.classList.remove('is-selected')
							this.tagMode = ''
							this.updateTabs()
						} else {
							this.tagEls.forEach((tagEl) => tagEl.classList.remove('is-selected'))
							tagEl.classList.add('is-selected')

							this.tagMode = tagEl.getAttribute('data-search-tag')

							this.updateTabs()
						}
					})
				})
			}

			handleViewMoreClickEvent() {
				if (!this.viewMoreBtnEl) return

				this.viewMoreBtnEl.addEventListener('click', () => {
					this.updateTabs(this.currentShowingQuestions + this.questionsPerPage)
				})
			}

			updateTabs(currentShowingQuestions) {
				if (!currentShowingQuestions) {
					currentShowingQuestions = this.questionsPerPage
				}

				// Variables
				const selectedCategories = []
				let totalValidTags = 0
				let totalValidShowingTags = 0

				// Update tags / categories
				this.collapsibleTabEls.forEach((collapsibleTabEl) => {
					const currentCategory = collapsibleTabEl.dataset.collapsibleCategory

					let isValid = true,
						isShow = true

					if (this.tagMode != '') {
						isValid = isValid && this.tagMode == currentCategory
					}

					if (this.searchMode != '') {
						const questionLabel = collapsibleTabEl.querySelector('[data-question-label]').textContent.toLowerCase()
						const shouldShow = questionLabel.includes(this.searchMode)

						isValid = isValid && shouldShow
					}

					totalValidTags += isValid ? 1 : 0

					if (isValid) {
						isShow = isValid && totalValidShowingTags < currentShowingQuestions

						isShow ? selectedCategories.push(currentCategory) : null
						totalValidShowingTags += isShow ? 1 : 0
					}

					collapsibleTabEl.classList.toggle('l-hidden', !isShow || !isValid)
				})

				// Update categories
				let categoryCount = 0
				this.categoryEls.forEach((categoryEl) => {
					const isShow = selectedCategories.indexOf(categoryEl.dataset.category) != -1

					categoryCount += isShow ? 1 : 0

					categoryEl.classList.toggle('is-first', categoryCount == 1)
					categoryEl.classList.toggle('l-hidden', selectedCategories.indexOf(categoryEl.dataset.category) == -1)
				})

				// Update Data
				this.allValidQuestions = totalValidTags
				this.currentShowingQuestions = totalValidShowingTags

				// Update view more button
				this.viewMoreBtnEl.classList.toggle('l-hidden', this.allValidQuestions <= currentShowingQuestions)
			}

			resetSearch() {
				this.searchInputEl.value = ''
			}
		}
	)
}

